import React from 'react'
import { ImLinkedin2 } from 'react-icons/im';
import { AiOutlineTwitter } from 'react-icons/ai';
import { FaWhatsapp } from 'react-icons/fa';
import { MdMailOutline } from 'react-icons/md';
import { AiOutlinePlus } from 'react-icons/ai';
import useIsInViewport from 'use-is-in-viewport'

import Heading2 from '../../../elements/titles/Heading2'
import Heading3 from '../../../elements/titles/Heading3'
import Paragraph from '../../../elements/p/Paragraph'
import Container from '../../../utils/Container'
import Button from '../../../elements/buttons/Button'
import bgTraductionTypes from '../../../../medias/images/bg-traductionTypes.svg'
import about1 from '../../../../medias/images/about1.png'
import about2 from '../../../../medias/images/Creative writing-rafiki.png'
import about3 from '../../../../medias/images/passionate-animate.png'
import about4 from '../../../../medias/images/Personal finance-pana.png'

const InfoBlock = () => {

	const [isInViewport, targetRef] = useIsInViewport()

	return (
		<section
			ref={targetRef}
			className={`${ isInViewport ? "visibleDiv" : "hiddenDiv"}`} 
		>
			<Container classe="">
				<div className="grid gap-y-8 md:gap-5 lg:gap-10 md:grid-cols-2 md:grid-rows-2 mt-16">
					<div>
						<Heading3 color="secondary" classe="mb-2">Comment se paye une mission de traduction ?</Heading3>
						<Paragraph classe="font-bold">
							Les tarifs dépendent de plusieurs facteurs
						</Paragraph>
						<ul className="list-disc list-inside">
							<li className="text-sm md:text-base font-nunito opacity-50"> Du nombre de mots à traduire  et la technicité du texte</li>
							<li className="text-sm md:text-base font-nunito opacity-50"> La langue source et le délai de livraison</li>
							<li className="text-sm md:text-base font-nunito opacity-50"> Du format du fichier  et de la régularité potentielle de vos besoins en traduction </li>
						</ul>
						<Paragraph classe="mt-5 font-bold">
							Conditions et mode de payement
						</Paragraph>
						<Paragraph>
							Le payement est demandé 30 jours après la date de facturation et le mode de payement que je préconise est le transfert bancaire international.
						</Paragraph>
						<Paragraph classe="mt-3">
							Si nécessaire,j’accepte également le payement via <b>PayPal</b> , <b>Orange Money</b> , <b>MTN Money</b> pour ceux de l’Afrique.
						</Paragraph>
					</div>

					<div>
						<Heading3 color="secondary" classe="mb-2">
							Comment juger un bon traducteur ?
						</Heading3>

						<Paragraph classe="mt-3 font-bold">
							Pour une  mission de traduction reussie, le traducteur doit presenter un certain nombre d'atout dont voici les plus importants
						</Paragraph>
						<ul className="list-disc list-inside">
							<li className="text-sm md:text-base font-nunito opacity-50"> Avoir reçu une formation appropriée. </li>
							<li className="text-sm md:text-base font-nunito opacity-50"> Être spécialisé dans les langues pour les quelles vous avez besoin de traduire.</li>
							<li className="text-sm md:text-base font-nunito opacity-50"> Savoir s’adapter parfaitement en fonction du type de document à traduire.</li>
							<li className="text-sm md:text-base font-nunito opacity-50"> Respecter les delais de livraison.</li>
							<li className="text-sm md:text-base font-nunito opacity-50"> Une collaboration efficace et fiable avec vous a également son importance.</li>
						</ul>
					</div>

					<div>
						<Heading3 color="secondary" classe="mb-2">
							Garantissez-vous la confidentialité des documents fournis ?
						</Heading3>

						<Paragraph>
							Je m’engage à préserver la confidentialité du contenu et de l’existence 
							de tous les documents que vous me fournissez. Je suis disposée à signer 
							tout accord de confidentialité que vous souhaiteriez me soumettre. 
							Vous pouvez donc me confier la traduction de vos documents sensibles en toute confiance.
						</Paragraph>
					</div>


					<div>
						<Heading3 color="secondary" classe="mb-2">
							Pourquoi ne pas se contenter de la traduction automatique ?
						</Heading3>

						<Paragraph>
							La traduction automatique peut s’avérer être un outil intéressant
							dans certaines situations. Elle peut par exemple suffire pour  se 
							faire une idée approximative du contenu d’un texte, mais la 
							traduction obtenue nécessitera une relecture humaine pour pouvoir être publiée. 
							Par ailleurs, les outils de traduction automatique ne garantissent nullement la 
							confidentialité de vos données. Dans tous les cas, si vous souhaitez 
							obtenir une traduction qui tient compte du contexte 
							( public cible ),
							qui emploie une terminologie technique fiable ou qui adopte un style rédactionnel soigné, 
							le recours à un traducteur humain est indispensable.
						</Paragraph>
					</div>

				</div>

				<div className="mt-20 md:mt-8 text-center">
					<div className="flex flex-col items-center">
						<Heading3 color="secondary" classe="mb-2">
							Pourquoi me choisir moi ?
						</Heading3>

						<p className=" max-w-md text-lg font-nunito opacity-50 text-center">
							Outre que la traducion, j’ai plusieurs autres compétences que je met 
							à votre disposition afin de rendre votre projet plus 
							agréable.
						</p>
					</div>

					<div className="flex justify-center mt-10">
						<Button
							link="/contact"
						>
							Traduire un projet
						</Button>
					</div>
				</div>
			</Container>
		</section>
	)
}

export default InfoBlock